export enum KpisQueryKey {
  KpisByTypes = 'kpis-by-types',
  MaterialQualityKpis = 'material-quality-kpis',
  MonthlyTrendsByTypes = 'kpis-monthly-trends-by-types',
  RunningTimesPlantEquipments = 'running-times-plant-equipments',
  Hierarchy = 'performance-hierarchy',
  EquipmentKilnKpisMtmStats = 'equipment-kiln-kpis-mtm-stats',
  EquipmentKilnKpisYtmStats = 'equipment-kiln-kpis-ytm-stats',
  EquipmentsKpisMtmStats = 'equipment-kpis-mtm-stats',
  EquipmentsKpisYtmStats = 'equipment-kpis-ytm-stats',
  EquipmentPerformances = 'equipment-performances',
  KpiDashboardPlantStatus = 'kpi-dashboard-plant-status',
  EquipmentStatus = 'equipment-status'
}
